export class CuttingCustomHoleSchema {
  id: number;
  name = '';
  diameter: number;
  minDepth: number;
  maxDepth: number;
  edgeHoleOffset: number;
  type: CustomHoleSchemaTypeEnum = CustomHoleSchemaTypeEnum.Plate;
}

export enum CustomHoleSchemaTypeEnum {
  Plate,
  Edge,
}
